import { z } from 'zod';

// The fan-group fans export job's request body (POST /reports/fangroup-fans-export). Mirrors
// the Node backend's FangroupFansExportBody.
//
// `badgeIds` is the pre-existing, differently-scoped field: waiting-list badge ids gating the
// (pre-existing) accepted-position export. The FGO Users screen's per-member Tag filter uses
// the distinct `memberBadgeIds` field below precisely to avoid colliding with it -- presence
// of any one of locationFilters/memberBadgeIds/query/userIds routes the job to the
// members-search-backed filtered export instead.
export const FanGroupFansExportValidatorSchema = z.object({
  fangroupSlug: z.string(),
  badgeIds: z.array(z.string()),
  subGroupIds: z.string().optional(),
  subGroups: z.string().optional(),
  locationFilters: z.array(z.string()).optional(),
  memberBadgeIds: z.array(z.string()).optional(),
  query: z.string().optional(),
  // Selection never sends more than a page of explicit ids (enforced by the FE); an
  // "all matching" export instead sends locationFilters/memberBadgeIds/query.
  userIds: z.array(z.string()).optional(),
});

export type FanGroupFansExportValidator = z.infer<
  typeof FanGroupFansExportValidatorSchema
>;
